import { EmailOutlined } from '@mui/icons-material'
import { Box, Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { authService } from '../../../services/authService'
import { toast } from 'react-toastify'
import { STAGES } from '../Signup'

import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

const CreateUserProfile = ({ userDetails, setUserDetails, isLoading, navigateToScreen }) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const saveDetailsChanges = async (e) => {
    e.preventDefault()
    // do logic here
    if (userDetails.is_new_user) {
      const res = await authService.updateUserDetails({ ...userDetails, user_id: userDetails.id })
      if (res.status) {
        setUserDetails({ ...userDetails, ...res.user })
        navigateToScreen(STAGES.ONBOARD_COMPANY)
      } else {
        toast.error('Something went wrong!')
      }
    } else {
      navigateToScreen(STAGES.ONBOARD_COMPANY)
    }
  }

  return (
    <Box
      component="form"
      onSubmit={saveDetailsChanges}
      className="onboardingForm"
      style={{
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        background: ' #fff',
        borderRadius: 12,
        boxShadow: '0 24px 64px #26214a1a',
        padding: '60px 60px',
      }}
    >
      <Typography
        variant="h5"
        color="textSecondary"
        style={{
          color: '#27104E',
          fontSize: '21px',
          marginBottom: '10px',
          fontWeight: '800',
        }}
      >
        Create Your Account
      </Typography>
      <Typography
        style={{ marginBottom: '30px', color: '#4E62BB', fontSize: '12px', textAlign: 'center' }}
      >
        Fill in your details to complete the registration.
      </Typography>

      <Box className="flexHorizontal">
        <TextField
          style={{ borderColor: '#D6D9DE', borderRadius: '10px' }}
          onChange={(e) => setUserDetails((state) => ({ ...state, first_name: e.target.value }))}
          label="First Name"
          variant="outlined"
          color="primary"
          autoFocus
          fullWidth
          value={userDetails.first_name}
          size="small"
          className="inputsout"
        />
        <TextField
          style={{ borderColor: '#D6D9DE', borderRadius: '10px' }}
          onChange={(e) => setUserDetails((state) => ({ ...state, last_name: e.target.value }))}
          label="Last Name"
          variant="outlined"
          color="primary"
          fullWidth
          value={userDetails.last_name}
          size="small"
          className="inputsout"
        />
      </Box>

      <TextField
        disabled
        type="email"
        style={{ borderColor: '#D6D9DE', borderRadius: '10px' }}
        onChange={(e) => setUserDetails((state) => ({ ...state, email: e.target.value }))}
        label="Email Address"
        variant="outlined"
        color="primary"
        fullWidth
        value={userDetails.email}
        size="small"
        className="inputsout"
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <EmailOutlined style={{ fontSize: 16, color: '#8790B7', marginRight: '-10' }} />
            </InputAdornment>
          ),
        }}
      />

      {userDetails.is_new_user ? (
        <TextField
          type={showPassword ? 'text' : 'password'}
          style={{ borderColor: '#D6D9DE', borderRadius: '10px' }}
          onChange={(e) => setUserDetails((state) => ({ ...state, password: e.target.value }))}
          label="Enter Password"
          variant="outlined"
          color="primary"
          fullWidth
          value={userDetails.password}
          size="small"
          className="inputsout"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                  onClick={handleClickShowPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ) : null}

      <Button
        fullWidth
        disabled={isLoading}
        color="primary"
        variant="contained"
        className="onboarding-btn"
        onClick={saveDetailsChanges}
        style={{ borderRadius: '9px' }}
        type="submit"
      >
        Save Changes
      </Button>
    </Box>
  )
}

export default CreateUserProfile
